<template>
  <div class="productHeader">
    <div
      class="productHeader__inner"
      :class="[
        'productHeader__inner',
        {
          'productHeader__inner--isFromMyOffer':
            productData.isFromMyOffer || productData.isFromCatalogSubset,
        },
      ]"
    >
      <div class="productHeader__gallery">
        <div v-if="productData.sponsoredOfferInfo" class="productHeader__offer">
          <span class="productHeader__offerText"> Oferta sponsorowana </span>
          <client-only>
            <v-popover :placement="$device.isMobile ? 'left' : 'top'" trigger="hover" offset="10">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                <g id="Group_23452" data-name="Group 23452" transform="translate(-255.5 -185.5)">
                  <circle
                    id="Ellipse_242"
                    data-name="Ellipse 242"
                    cx="7.5"
                    cy="7.5"
                    r="7.5"
                    transform="translate(256.5 186.5)"
                    fill="none"
                    stroke="#abb0b9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    id="Path_11538"
                    data-name="Path 11538"
                    d="M12.651,14.605h-.888V11.25h-.888"
                    transform="translate(252.237 182.158)"
                    fill="none"
                    stroke="#abb0b9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                  <path
                    id="Path_11539"
                    data-name="Path 11539"
                    d="M11.657,8.058h0a.2.2,0,1,1,0,.279.2.2,0,0,1,0-.279"
                    transform="translate(252.084 182.842)"
                    fill="none"
                    stroke="#abb0b9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </g>
              </svg>
              <template slot="popover">
                <div v-close-popover>
                  <div :class="[{ 'popoverTooltip--mobile': $device.isMobile }]">
                    {{ productData.sponsoredOfferInfo }}
                  </div>
                </div>
              </template>
            </v-popover>
          </client-only>
        </div>
        <product-badges :badges="productData.badges" inline />
        <product-gallery :alt="productData.name" :gallery="gallery" />
        <div class="productHeader__actions">
          <product-actions :is-on-list="isOnShoppingList" :product="productData" />
        </div>
      </div>
      <div class="productHeader__content">
        <nuxt-link
          :to="
            localePath({
              name: 'brand-slug',
              params: {
                slug: productData.brand.slug,
              },
            })
          "
        >
          <div
            v-if="productData.brand && productData.brand.logoUrl100x80"
            class="productHeader__logo"
          >
            <new-image-box
              :alt="productData.name"
              :src="productData.brand.logoUrl100x80"
              :width="100"
              :height="80"
              loading="eager"
              image-params="w_100,h_80"
            />
          </div>
        </nuxt-link>

        <h1 class="productHeader__name">
          {{ productData.name }}
        </h1>
        <product-trusmate-stars
          v-if="!productData.outletType"
          :key="productData.id"
          :product="productData.id"
        />

        <!--        <product-rating-stars class="productHeader__rating" :stars="4" big />-->
        <product-tags :tags="tags" />
        <product-details
          v-if="productData.attributesForFrontend && productData.attributesForFrontend.length"
          :list="productData.attributesForFrontend"
          :outlet="productData.outletType"
          :collapse-count="4"
          class="productHeader__details"
        />
        <div
          v-if="productData.attributesForFrontend && !productData.attributesForFrontend.length"
          class="productHeader__break"
        />
        <product-variants
          v-if="productData.variants && productData.variants.length > 1"
          :variants="productData.variants"
          :active-product="productData.slug"
          :product="productData"
          @change-variant="changeGalleryFirstImage"
        />
        <div
          v-if="
            productData.variants &&
            productData.variants.length > 1 &&
            productData.members &&
            productData.members.length > 1
          "
          class="productHeader__break"
        />
        <product-pack-members
          v-if="productData.members && productData.members.length > 1"
          :product="productData"
          :members="productData.members"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import ProductRatingStars from './ProductRatingStars';
import { VClosePopover, VPopover } from 'v-tooltip';
import ProductTags from './ProductTags';
import ProductDetails from './ProductDetails';
import ProductGallery from './ProductGallery';
import ProductBadges from './ProductBadges';
import ProductActions from './ProductActions';
import ProductVariants from './ProductVariants';
import NewImageBox from '@/components/NewImageBox';
import ProductPackMembers from '@/components/Product/ProductPackMembers.vue';
import ProductTrusmateStars from '@/components/Product/ProductTrusmateStars.vue';

export default {
  name: 'ProductHeader',
  components: {
    ProductTrusmateStars,
    ProductPackMembers,
    NewImageBox,
    ProductVariants,
    ProductActions,
    ProductBadges,
    ProductGallery,
    ProductDetails,
    ProductTags,
    VPopover,
    // ProductRatingStars,
  },
  directives: {
    closePopover: VClosePopover,
  },
  props: {
    isOnShoppingList: {
      type: Boolean,
      default: false,
    },
    productData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isCollapse: false,
      gallery: [],
    };
  },

  computed: {
    tags() {
      return [
        {
          name: this.$t('code'),
          value: this.productData.code,
        },
        {
          color: this.productData.availabilityMarkColor.color,
          value: this.productData.whenProductWillBeAtYourPlace,
        },
      ];
    },
  },
  mounted() {
    this.setGalleryItems();
  },
  methods: {
    setGalleryItems() {
      const gallery = [];
      if (this.productData?.gallery?.main) {
        gallery.push(this.productData.gallery.main);
      }

      if (this.productData?.gallery?.stat.length) {
        this.productData.gallery.stat.forEach(image => {
          gallery.push(image);
        });
      }

      if (this.productData?.gallery?.pack.length) {
        this.productData.gallery.pack.forEach(image => {
          gallery.push(image);
        });
      }

      if (this.productData?.gallery?.use.length) {
        this.productData.gallery.use.forEach(image => {
          gallery.push(image);
        });
      }

      this.gallery = gallery;
    },
    changeGalleryFirstImage(e) {
      if (e) {
        this.gallery[0] = {
          alt: e.name,
          url80x60: e.mainPictureUrl150x150,
          urlFull: e.mainPictureUrl,
        };
      } else {
        this.gallery[0] = this.productData.gallery.main;
      }

      this.gallery = [...this.gallery];
    },
    toggle() {
      this.isCollapse = this.isCollapse !== true;
    },
  },
};
</script>

<style lang="scss">
.productHeader {
  position: relative;
  box-shadow: 0 5px 15px rgba(23, 25, 51, 0.03);
  z-index: 1;

  &__inner {
    display: flex;
    flex-wrap: wrap;
    padding: 3rem;
    background-color: $cWhite;

    @include rwd('small-tablet') {
      padding: 3rem 2rem 0;
    }

    &--isFromMyOffer {
      border: 1px solid $cMain;
    }
  }

  &__actions {
    position: absolute;
    right: 3rem;
    top: 3rem;
  }

  &__offer {
    position: relative;
    display: flex;
    padding-bottom: 1rem;
    align-items: center;
  }

  &__offerText {
    padding-right: 0.5rem;
    font-size: 1.2rem;
    line-height: 2rem;
    color: $cMainNeutral;
  }

  &__gallery {
    flex: 0 0 60%;
    max-width: 60%;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__content {
    flex: 0 0 40%;
    max-width: 40%;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__logo {
    display: flex;
    margin-bottom: 1.5rem;
    max-width: 170px;
    max-height: 100px;

    @include rwd('small-tablet') {
      margin-bottom: 1rem;
      max-width: 80px;
      max-height: 50px;
    }
  }

  &__name {
    margin-bottom: 1rem;
    font-size: 2.4rem;
    line-height: 2.9rem;
    max-width: 370px;

    @include rwd('tablet') {
      font-size: 2rem;
      line-height: 2.4rem;
      margin-bottom: 1rem;
    }
  }

  &__rating {
    margin-bottom: 0.6rem;
  }

  &__details {
    margin-bottom: 2rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
    border-top: 1px solid $cAddLight;
    border-bottom: 1px solid $cAddLight;

    @include rwd('small-tablet') {
      display: none;
    }
  }

  &__break {
    border-bottom: 1px solid $cAddLight;
    margin-top: 1rem;
    margin-bottom: 1.6rem;
  }
}
</style>
